import { render, staticRenderFns } from "./dataBodyPart.vue?vue&type=template&id=e8097e36&"
import script from "./dataBodyPart.vue?vue&type=script&lang=js&"
export * from "./dataBodyPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports